<template>
    <b-modal v-model="show" title="ПАРАМЕТЕР" size="lg" :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Вилоятни танланг <span class="red">*</span></label>
                        <v-select
                                label="name"
                                v-model="dictionaryData.data.province"
                                :filterable="false"
                                :options="provinces"
                                :class="{invalid: $v.dictionaryData.data.province.id.$error}"
                        >
                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                        </v-select>
                        <div class="red" v-if="$v.dictionaryData.data.province.id.$error">Туманни танланг</div>
                    </div>
                    <div class="form-group">
                        <label>Қарор сони <span class="red">*</span></label>
                        <input class="form-control" type="text"
                               v-model="dictionaryData.data.decisionNumber"
                               :class="{invalid: $v.dictionaryData.data.decisionNumber.$error}"
                        />
                    </div>
                    <div class="form-group">
                        <label>Қарор санаси <span class="red">*</span></label>
                        <datepicker class="form-control" format="dd/MM/yyyy"
                                    v-model="decisionDate"
                                    :clear-button="true"
                                    :class="{invalid : $v.decisionDate.$error}">
                                    </datepicker>
                    </div>
                </div>
                <div>
                    <DropZone code="rentalRatesForLegal"
                                        folder="Settings"
                                        subFolder="RentalRatesApplication"
                                        label="Илова *"
                                        view="BUILDING" :data="dictionaryData.applications"
                                        @change="(photos) => {dictionaryData.applications = photos}"
                                        :has-error="$v.dictionaryData.applications.$error"
                    />
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" @click="save" :disabled="processing">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="close">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {required, minLength} from 'vuelidate/lib/validators';
    import DropZone from '@/views/dropZone/DropZone'
    import Datepicker from 'vuejs-datepicker';
    import {formatDate} from '@/shared/utils';
    import initFilterModel from '@/shared/filter';

    export default {
        name: "RRApplicationLegalEditModal",
        components: {
            'b-modal': bModal,
            DropZone,
            Datepicker
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                filterProvince: initFilterModel(),
                dictionaryData: this.initData(),
                provinces: [],
                decisionDate: null
            }
        },
        validations() {
            return {
                dictionaryData: {
                    data: {
                        province: {
                            id: {
                                required: required
                            }
                        },
                        decisionNumber: {
                            required: required
                        }
                    },
                    applications: {
                        required: required,
                        minLength: minLength(1)
                    }
                },
                decisionDate: {
                    required: required
                }
            }
        },
        methods: {
            initData() {
                return {
                    id: null,
                    dictionaryType: 'RENTAL_RATES_APPLICATION_FOR_LEGAL',
                    data: {
                        province: null,
                        decisionNumber: ''
                    },
                    applications: []
                }
            },
            init() {
                const vm = this;
                vm.provinces = [];
                vm.filterProvince.search = '';
                this.$http.post('/province/list', vm.filterProvince)
                    .then(res => {
                        vm.provinces = this.getAsMaps(res.data);
                    }, err => {
                        console.log(err);
                    });
            },
            getAsMaps(result) {
                if (result && result.data && result.data.length > 0) {
                    return result.data.map(d =>({id: d.id, name: d.name}))
                }
                return [];
            },
            save() {

                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                if (this.decisionDate) {
                    this.dictionaryData.data.decisionDate = formatDate(this.decisionDate);
                }

                const vm = this;
                this.processing = true;
                this.$http.post('dictionary/save/real-estate/rental-rates',this.dictionaryData)
                    .then(res => {
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$emit('change')
                        }
                        vm.processing = false;
                    },err => {
                        vm.processing = false;
                        console.log(err);
                    });

            },
            close() {
                this.show = false
            }
        },
        created() {
            this.filterProvince.page.size = 1000;
            this.init();
            this.$eventBus.$on("showRRApplicationLegalEditModal", (data) => {
                if (data) {
                    console.log(data)
                } else {
                    this.dictionaryData = this.initData();
                    this.decisionDate = null;
                }
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>